<script>
import { Line } from 'vue-chartjs';
import { CustomTooltips } from '@coreui/coreui-plugin-chartjs-custom-tooltips';
import { hexToRgba } from '@coreui/coreui/dist/js/coreui-utilities';
import { mapGetters, mapActions } from 'vuex';
import { format } from 'date-fns';

export default {
  components: {
    hexToRgba,
    CustomTooltips,
  },
  computed: {
    ...mapGetters(['visitasNosUltimosTresMesses', 'sizeGrafficVisitasPorAno']),
  },
  methods: mapActions(['buscarHistoricoVisitasDosUltimosTresMesses']),

  extends: Line,
  async mounted() {
    await this.buscarHistoricoVisitasDosUltimosTresMesses();

    const visitas = this.visitasNosUltimosTresMesses;
    console.log(visitas);


    this.renderChart(
      {
        labels: [
          '01', '02', '03', '04', '05', '06', '07', '08', '09', '10',
          '11', '12', '13', '14', '15', '16', '17', '18', '19', '20',
          '21', '22', '23', '24', '25', '26', '27', '28', '29', '30', '31',
        ],
        datasets: [
          {
            label: format(new Date(), 'MMMM'),
            backgroundColor: hexToRgba('#4caf50', 90),
            data: visitas[0],
          },
          {
            label: 'last month',
            backgroundColor: hexToRgba('#2196f3', 90),
            data: visitas[1],
          },
          {
            label: 'month relocated',
            backgroundColor: hexToRgba('#009688', 100),
            data: visitas[2],
          },
        ],
      },
      {
        responsive: true,
        maintainAspectRatio: true,
        tooltips: {
          enabled: false,
          custom: CustomTooltips,
          intersect: true,
          mode: 'index',
          position: 'nearest',
          callbacks: {
            labelColor(tooltipItem, chart) {
              return {
                backgroundColor:
                  chart.data.datasets[tooltipItem.datasetIndex].backgroundColor,
              };
            },
          },
        },
      },
    );
  },
};
</script>
